import { useSelector } from 'react-redux';

import AuthSlice from './auth';

export interface IAuthStates {
	[AuthSlice.name]: ReturnType<typeof AuthSlice.reducer>;
}

export const useAuthStates = (): ReturnType<typeof AuthSlice.reducer> =>
	useSelector((state: IAuthStates) => state.auth);

export const useRefreshList = (): boolean => useSelector((state: IAuthStates) => state.auth.listUpdate);
